<template>
    <div class="section pt-1">
        <div class="row mt-1">
            <div class="col-12">
                <div class="stat-box">
                    <div class="title mal-text">പരീക്ഷ എഴുതിയവർ (Total)</div>
                    <div class="value text-primary">{{ count_total }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="section" v-if="exams && exams.length">
        <div class="row mt-1">
            <div class="col-12">
                <label class="label mal-text" for="exam">പരീക്ഷ</label>
                <select id="exam" class="form-control" v-model="exam_id" @change="fetchReport">
                    <option value="">എല്ലാം</option>
                    <option v-for="exam in exams" :key="exam.id" :value="exam.id">{{ exam.name || 'Exam ' + exam.id }}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3">
            <h3 class="text-center mt-2 mal-text custom-title">{{ page_title }}</h3>
        </div>
    </div>
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && (!list || list.length === 0)">ഡാറ്റ ഇല്ല</h4>
    </div>
    <div class="section mt-2 mb-2" v-if="!loading_list && list && list.length > 0">
        <div class="card">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" class="mal-text">പേര്</th>
                            <th scope="col" class="mal-text text-right">എണ്ണം</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in list" :key="item.id || index">
                            <td class="text-primary font-dark">{{ index + 1 }}</td>
                            <td class="text-primary font-dark">
                                <router-link
                                    v-if="canDrillDown"
                                    :to="districtReportPath(item)"
                                    class="text-primary font-dark"
                                >
                                    {{ item.name }}
                                </router-link>
                                <span v-else class="mal-text">{{ item.name }}</span>
                            </td>
                            <td class="text-primary font-dark text-right">{{ item.attempt_count || 0 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from "@/services/user.service";

export default {
    name: 'ExamAttemptsReport',
    data() {
        return {
            loading_list: false,
            list: [],
            count_total: 0,
            page_title: '',
            level: null,
            year: new Date().getFullYear().toString(),
            exam_id: '',
            exam_type: 'QVP',
            exams: [],
            user_level: null,
        };
    },
    computed: {
        currentUser() {
            return this.$store && this.$store.state && this.$store.state.auth ? this.$store.state.auth.user : null;
        },
        canDrillDown() {
            return this.user_level != null && this.user_level <= 2;
        },
        districtReportPath() {
            return (item) => {
                if (!item || item.id == null) return '#';
                const nextLevel = this.user_level + 1;
                return `/org/${nextLevel}/${item.id}/exam-attempts-report`;
            };
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            if (this.$root && this.$root.updateParent) {
                this.$root.updateParent('പരീക്ഷ എഴുതിയവർ റിപ്പോർട്ട്');
            }
            this.fetchReport();
        }
    },
    methods: {
        fetchReport() {
            this.loading_list = true;
            const data = {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id) || 0,
                exam_type: this.exam_type,
                year: this.year,
            };
            if (this.exam_id) {
                data.exam_id = parseInt(this.exam_id);
            }
            UserService.authPostRequest('get-exam-attempts-report', data).then(
                (response) => {
                    if (response.data.status === 'success' && response.data.data) {
                        this.list = response.data.data.list || [];
                        this.count_total = response.data.data.count_total || 0;
                        this.page_title = response.data.data.page_title || 'പരീക്ഷ എഴുതിയവർ റിപ്പോർട്ട്';
                        this.level = response.data.data.level;
                        this.exams = response.data.data.exams || [];
                    } else {
                        this.list = [];
                        this.count_total = 0;
                        this.page_title = response.data.data ? (response.data.data.page_title || '') : '';
                    }
                    this.loading_list = false;
                },
                (error) => {
                    this.loading_list = false;
                    this.list = [];
                    this.count_total = 0;
                    const msg = (error.response && error.response.data && error.response.data.message) || error.message || 'Error loading report';
                    if (this.$toast) this.$toast.open(msg); else alert(msg);
                }
            );
        },
    },
};
</script>

<style scoped>
/* Total card: more height, larger fonts */
.stat-box {
    padding: 14px 16px;
    min-height: 72px;
}
.stat-box .title {
    font-size: 15px;
    margin-bottom: 6px;
    color: #374151;
}
.stat-box .value {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1.2em;
    color: #27173E;
}
.label {
    display: block;
    margin-bottom: 4px;
    font-size: 13px;
    font-weight: 600;
    color: #1a418c;
}
</style>
